import { Icon } from "@iconify/react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";

import Badge from "@mui/material/Badge";
import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logoutChannel } from "../auth/broadcastSetup";
import { useNavigate } from "react-router-dom";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
import { credit } from "../store/creditSlice";
import { Logout } from "@mui/icons-material";

export default function AccountPopover() {
  console.log("sssdsdsd");
  const [open, setOpen] = useState(null);
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const { data = {}, status } = useSelector((state) => state.credit);
  const navigate = useNavigate();
  const [allData, setAllData] = useState([]);

  useEffect(() => {
    dispatch(credit());
    console.log("Dispatching after credit API call...");
  }, []);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogOut = () => {
    const token = getAccesstoken();
    axios
      .get(`${base_url}/digilocker/LogOut`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.message === "Logged Out Successfully") {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("email");
          sessionStorage.removeItem("access");
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refresh");
          window.location.replace("/login");
          logoutChannel.postMessage("logout");
        }
      });
  };

  useEffect(() => {
    if (data.status) {
      console.log(data);
      setAllData(data?.credit_balance);
    }
  }, [data, data.status]);

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    return words.length > 1
      ? `${words[0][0]}${words[1][0]}`.toUpperCase()
      : `${words[0][0]}`.toUpperCase();
  };

  return (
    <Wrapper style={{ display: "flex", alignItems: "center", gap: "15px" }}>
      <Box
        sx={{
          height: 40,
          backgroundColor: "#FFF5E9",
          display: "flex",
          alignItems: "center",
          gap: 1,
          padding: "0 12px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
        onClick={() => {
          navigate("/dashboard");
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/credit.png`}
          alt="Credit"
          style={{ width: 21, height: 21 }}
        />
        <Typography
          sx={{ fontWeight: 500, fontSize: "16px", color: "#000000" }}
        >
          {allData || 0} Credits
        </Typography>
      </Box>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
            },
          }),
        }}
      >
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          justifyContent={"start"}
        >
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
          >
            <Avatar
              sx={{
                width: 44,
                height: 44,
                bgcolor: "#F1D4FF",
                color: "#A73ED7",
                fontWeight: "bold",
                fontSize: 16,
              }}
              alt={profileData?.company_name || ""}
              src={profileData?.logo || ""}
              onError={(e) => (e.target.src = "")}
            >
              {getInitials(profileData?.company_name)}
            </Avatar>
          </StyledBadge>
          <Stack
            alignItems={"start"}
            sx={{
              color: "#1D1D1D",
              flexDirection: "row",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">{profileData.company_name}</Typography>
            <Stack
              alignItems={"center"}
              direction="row"
              sx={{ color: "black" }}
            >
              <Icon icon="material-symbols:arrow-drop-down" />
            </Stack>
          </Stack>
        </Stack>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: "auto",
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {profileData.company_email}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: "dashed" }} />
        {/* <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="body2" noWrap>
            Secret token :{" " + profileData.username}
          </Typography>
        </Box> */}

        {/* <Divider sx={{ borderStyle: "dashed" }} />
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="body2" noWrap>
            Negative Index :{" " + profileData.isNegativeRunning}
          </Typography>
        </Box> */}

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem
          onClick={handleLogOut}
          sx={{
            m: 1,
            display: "flex",
            justifyContent: "space-between",
            gap: "5px",
          }}
        >
          <Logout />
          <span>Logout</span>
        </MenuItem>
      </Popover>
    </Wrapper>
  );
}

const StyledBadge = muiStyled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const Wrapper = styled.div`
  .MuiAvatar-img {
    height: fit-content;
  }
`;
